import React, { useState } from 'react';

export default function ThinkyIOTDeployment({ onBack }) {
  const [nodes] = useState([
    { id: 1, name: 'Cloud Node 1', type: 'Cloud', status: 'Online', uptime: '99.9%' },
    { id: 2, name: 'Edge Node A', type: 'Edge', status: 'Online', uptime: '97.5%' },
    { id: 3, name: 'Edge Node B', type: 'Edge', status: 'Offline', uptime: '92.1%' },
    { id: 4, name: 'Hybrid Node X', type: 'Hybrid', status: 'Online', uptime: '98.3%' },
  ]);

  return (
    <div className="min-h-screen bg-black text-white px-4 py-8">
      <button onClick={onBack} className="mb-6 px-4 py-2 bg-blue-600 rounded hover:bg-blue-500 w-24">&larr; Back</button>
      <h1 className="text-lg lg:text-xl font-bold mb-6">Cloud, Edge & Hybrid Deployment</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {nodes.map(node => (
          <div key={node.id} className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm">
            <h3 className="text-lg font-semibold mb-2">{node.name}</h3>
            <p>Type: <span className="text-blue-400 font-medium">{node.type}</span></p>
            <p>Status: <span className={`${node.status === 'Online' ? 'text-green-400' : 'text-red-500'} font-semibold`}>{node.status}</span></p>
            <p>Uptime: <span className="font-medium">{node.uptime}</span></p>
          </div>
        ))}
      </div>

      <section className="mt-8">
        <h2 className="text-lg font-semibold mb-3">Deployment Summary</h2>
        <ul className="list-disc list-inside text-sm">
          <li>Total Nodes: {nodes.length}</li>
          <li>Cloud Nodes: {nodes.filter(n => n.type==='Cloud').length}</li>
          <li>Edge Nodes: {nodes.filter(n => n.type==='Edge').length}</li>
          <li>Hybrid Nodes: {nodes.filter(n => n.type==='Hybrid').length}</li>
          <li>Offline Nodes: {nodes.filter(n => n.status==='Offline').length}</li>
        </ul>
      </section>
    </div>
  );
}
